export default [
  {
    path: 'wallet/balance',
    name: 'Balance',
    component: () => import('@/views/wallet/balance/index.vue'),
    meta: {
      icon: 'icon-wallet',
      resourceCode: 'wallet:balance',
    },
  },
  {
    path: 'wallet/balance/aggregate/:type',
    name: 'Balance Aggregate',
    component: () => import('@/views/wallet/balance/index_aggregate.vue'),
    meta: {
      icon: 'icon-wallet',
      resourceCode: 'wallet:balance',
    },
  },
  {
    path: 'wallet/balance/view',
    name: 'Balance Details',
    component: () => import('@/views/wallet/balance-details/index.vue'),
    meta: {
      resourceCode: 'wallet:balance:detail',
      activeMenu: '/wallet/balance',
      name: 'message.settlement.accountBalance',
    },
  },
  {
    path: 'wallet/balance/batch/view',
    name: 'Batch Details',
    component: () => import('@/views/wallet/batch-details/index.vue'),
    meta: {
      resourceCode: 'wallet:balance:batch:detail',
      activeMenu: '/wallet/balance',
    },
  },
  {
    path: 'wallet/exchange',
    name: 'Exchange',
    component: () => import('@/views/wallet/exchange/list/index.vue'),
    meta: {
      resourceCode: 'wallet:exchange',
      activeMenu: '/wallet/exchange',
    },
  },
  {
    path: 'wallet/exchange/add/amount',
    name: 'Exchange add amount',
    component: () => import('@/views/wallet/exchange/add/amount/index.vue'),
    meta: {
      resourceCode: 'wallet:exchange/add',
      activeMenu: '/wallet/exchange',
      hideMenu: true,
    },
  },
  {
    path: 'wallet/exchange/add/review',
    name: 'Exchange add review',
    component: () => import('@/views/wallet/exchange/add/review/index.vue'),
    meta: {
      resourceCode: 'wallet:exchange/add',
      activeMenu: '/wallet/exchange',
      hideMenu: true,
    },
  },
  {
    path: 'wallet/settlement',
    name: 'Settlement',
    redirect: '/wallet/settlement/batch',
    meta: {
      resourceCode: 'wallet:settlement',
      activeMenu: '/wallet/exchange',
    },
  },
  {
    path: 'wallet/settlement/batch',
    name: 'Settlement Batch',
    component: () => import('@/views/wallet/settlement-batch/index.vue'),
    meta: {
      resourceCode: 'wallet:settlement:batch',
      activeMenu: '/wallet/settlement',
    },
  },
  {
    path: 'wallet/settlement/details',
    name: 'Settlement Detail',
    component: () => import('@/views/wallet/settlement-details/index.vue'),
    meta: {
      resourceCode: 'wallet:settlement:detail',
      activeMenu: '/wallet/settlement',
    },
  },
];
